import { Component, OnInit } from '@angular/core';
import { DesignService } from '../service/design.service';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from '../service/order.service';
import { SingleComponent } from '../components/single/single.component'; 

@Component({
  selector: 'app-admin-orders',
  templateUrl: './admin-orders.component.html',
  styleUrls: ['./admin-orders.component.scss']
})
export class AdminOrdersComponent implements OnInit {

  orders: any = []
  constructor( private orderService: OrderService, private designService: DesignService, private matDialog: MatDialog ) { }

  ngOnInit(): void {
    this.orderService.getAllOrders().then((resp: any = []) => {
      this.orders = resp
    })
  }

  generate_orer_tree(order){
    let design;
    // get settings
    localStorage.setItem('admin', 'admin')
    this.designService.getOrderdDesignById(order.settings_id).then((d) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.data = 'test';
      const modalDialog = this.matDialog.open(SingleComponent, dialogConfig);
    })

  }
}
